// Servicio para generar datos de prueba del sistema de inventario
import inventoryService from './inventoryService';

export interface TestData {
  brands: Array<{
    name: string;
    description: string;
    website?: string;
    contactEmail?: string;
  }>;
  suppliers: Array<{
    name: string;
    contactPerson: string;
    email: string;
    phone: string;
    address: string;
    paymentTerms: string;
    notes?: string;
  }>;
  products: Array<{
    name: string;
    category: string;
    stock: number;
    priceCost: number;
    priceSale: number;
    brand: string;
    supplier: string;
    imageURL?: string;
    fechaIngreso?: string;
    data: Record<string, any>;
  }>;
}

class TestDataService {
  private getTestData(): TestData {
    return {
      brands: [
        {
          name: 'Nike',
          description: 'Marca deportiva líder mundial',
          website: 'https://nike.com',
          contactEmail: 'contact@nike.com'
        },
        {
          name: 'Adidas',
          description: 'Tres rayas, una marca',
          website: 'https://adidas.com',
          contactEmail: 'contact@adidas.com'
        },
        {
          name: 'Puma',
          description: 'Forever Faster',
          website: 'https://puma.com',
          contactEmail: 'contact@puma.com'
        },
        {
          name: 'Reebok',
          description: 'Be More Human',
          website: 'https://reebok.com',
          contactEmail: 'contact@reebok.com'
        },
        {
          name: 'Converse',
          description: 'All Star',
          website: 'https://converse.com',
          contactEmail: 'contact@converse.com'
        },
        {
          name: 'Vans',
          description: 'Off The Wall',
          website: 'https://vans.com',
          contactEmail: 'contact@vans.com'
        },
        {
          name: 'Levi\'s',
          description: 'Calidad y estilo desde 1853',
          website: 'https://levi.com',
          contactEmail: 'contact@levi.com'
        },
        {
          name: 'Zara',
          description: 'Moda rápida y accesible',
          website: 'https://zara.com',
          contactEmail: 'contact@zara.com'
        }
      ],
      suppliers: [
        {
          name: 'Proveedor Textil ABC',
          contactPerson: 'Juan Pérez',
          email: 'juan@proveedorabc.com',
          phone: '+54 11 1234-5678',
          address: 'Av. Corrientes 1234, CABA',
          paymentTerms: '30 días',
          notes: 'Proveedor confiable, entrega puntual'
        },
        {
          name: 'Distribuidora XYZ',
          contactPerson: 'María González',
          email: 'maria@distribuidoraxyz.com',
          phone: '+54 11 9876-5432',
          address: 'Av. Santa Fe 5678, CABA',
          paymentTerms: '15 días',
          notes: 'Especialistas en calzado deportivo'
        },
        {
          name: 'Importadora DEF',
          contactPerson: 'Carlos Rodríguez',
          email: 'carlos@importadoradef.com',
          phone: '+54 11 5555-1234',
          address: 'Av. Rivadavia 9012, CABA',
          paymentTerms: '45 días',
          notes: 'Importación directa, precios competitivos'
        },
        {
          name: 'Textiles del Sur',
          contactPerson: 'Ana Martínez',
          email: 'ana@textilessur.com',
          phone: '+54 11 4444-8888',
          address: 'Av. 9 de Julio 3456, CABA',
          paymentTerms: '20 días',
          notes: 'Especialistas en algodón orgánico'
        },
        {
          name: 'Moda Express',
          contactPerson: 'Roberto Silva',
          email: 'roberto@modaexpress.com',
          phone: '+54 11 7777-9999',
          address: 'Av. Córdoba 7890, CABA',
          paymentTerms: '25 días',
          notes: 'Entrega rápida, productos de temporada'
        }
      ],
      products: [
        // Camperas
        {
          name: 'Campera Nike Negra Deportiva',
          category: 'Campera',
          stock: 15,
          priceCost: 5000,
          priceSale: 8000,
          brand: 'Nike',
          supplier: 'Proveedor Textil ABC',
          imageURL: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400',
          fechaIngreso: '2024-01-15',
          data: {
            tipo: 'deportiva',
            genero: 'unisex',
            talle: 'M',
            colorPrincipal: 'negro'
          }
        },
        {
          name: 'Campera Adidas Azul Rompeviento',
          category: 'Campera',
          stock: 8,
          priceCost: 4500,
          priceSale: 7500,
          brand: 'Adidas',
          supplier: 'Distribuidora XYZ',
          imageURL: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400',
          fechaIngreso: '2024-02-10',
          data: {
            tipo: 'rompeviento',
            genero: 'hombre',
            talle: 'L',
            colorPrincipal: 'azul'
          }
        },
        {
          name: 'Campera Puma Gris Bomber',
          category: 'Campera',
          stock: 12,
          priceCost: 4200,
          priceSale: 6800,
          brand: 'Puma',
          supplier: 'Importadora DEF',
          imageURL: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400',
          data: {
            tipo: 'bomber',
            genero: 'mujer',
            talle: 'S',
            colorPrincipal: 'gris'
          }
        },
        // Buzos
        {
          name: 'Buzo Nike Con Capucha Negro',
          category: 'Buzo',
          stock: 20,
          priceCost: 3000,
          priceSale: 5000,
          brand: 'Nike',
          supplier: 'Proveedor Textil ABC',
          imageURL: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400',
          data: {
            tipo: 'con capucha',
            materialPrincipal: 'algodón',
            estilo: 'casual',
            genero: 'unisex',
            talle: 'M',
            colorPrincipal: 'negro'
          }
        },
        {
          name: 'Buzo Adidas Sin Capucha Azul',
          category: 'Buzo',
          stock: 18,
          priceCost: 2800,
          priceSale: 4800,
          brand: 'Adidas',
          supplier: 'Distribuidora XYZ',
          imageURL: 'https://images.unsplash.com/photo-1571945153237-4929e783af4a?w=400',
          data: {
            tipo: 'sin capucha',
            materialPrincipal: 'frisa',
            estilo: 'deportivo',
            genero: 'hombre',
            talle: 'L',
            colorPrincipal: 'azul'
          }
        },
        {
          name: 'Buzo Puma Canguro Gris',
          category: 'Buzo',
          stock: 14,
          priceCost: 3200,
          priceSale: 5200,
          brand: 'Puma',
          supplier: 'Importadora DEF',
          imageURL: 'https://images.unsplash.com/photo-1583743814966-8936f37f4a8a?w=400',
          data: {
            tipo: 'canguro',
            materialPrincipal: 'fleece',
            estilo: 'streetwear',
            genero: 'mujer',
            talle: 'S',
            colorPrincipal: 'gris'
          }
        },
        // Camisas
        {
          name: 'Camisa Levi\'s Formal Azul',
          category: 'Camisa',
          stock: 25,
          priceCost: 2500,
          priceSale: 4200,
          brand: 'Levi\'s',
          supplier: 'Textiles del Sur',
          imageURL: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=400',
          data: {
            tipo: 'formal',
            materialPrincipal: 'algodón',
            genero: 'hombre',
            talle: 'M',
            colorPrincipal: 'azul'
          }
        },
        {
          name: 'Camisa Zara Casual Blanca',
          category: 'Camisa',
          stock: 22,
          priceCost: 1800,
          priceSale: 3200,
          brand: 'Zara',
          supplier: 'Moda Express',
          imageURL: 'https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=400',
          data: {
            tipo: 'casual',
            materialPrincipal: 'algodón',
            genero: 'mujer',
            talle: 'S',
            colorPrincipal: 'blanco'
          }
        },
        {
          name: 'Camisa Nike Polo Roja',
          category: 'Camisa',
          stock: 16,
          priceCost: 2200,
          priceSale: 3800,
          brand: 'Nike',
          supplier: 'Proveedor Textil ABC',
          imageURL: 'https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=400',
          data: {
            tipo: 'polo',
            materialPrincipal: 'poliéster',
            genero: 'hombre',
            talle: 'L',
            colorPrincipal: 'rojo'
          }
        },
        // Remeras
        {
          name: 'Remera Nike Básica Negra',
          category: 'Remera',
          stock: 30,
          priceCost: 1200,
          priceSale: 2200,
          brand: 'Nike',
          supplier: 'Proveedor Textil ABC',
          imageURL: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400',
          data: {
            tipo: 'básica',
            materialPrincipal: 'algodón',
            genero: 'unisex',
            talle: 'M',
            colorPrincipal: 'negro'
          }
        },
        {
          name: 'Remera Adidas Estampada Blanca',
          category: 'Remera',
          stock: 28,
          priceCost: 1500,
          priceSale: 2800,
          brand: 'Adidas',
          supplier: 'Distribuidora XYZ',
          imageURL: 'https://images.unsplash.com/photo-1529258283598-8d6fe60b27f4?w=400',
          data: {
            tipo: 'estampada',
            materialPrincipal: 'algodón',
            genero: 'mujer',
            talle: 'S',
            colorPrincipal: 'blanco'
          }
        },
        {
          name: 'Remera Puma Con Logo Gris',
          category: 'Remera',
          stock: 24,
          priceCost: 1400,
          priceSale: 2600,
          brand: 'Puma',
          supplier: 'Importadora DEF',
          imageURL: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400',
          data: {
            tipo: 'con logo',
            materialPrincipal: 'algodón',
            genero: 'hombre',
            talle: 'L',
            colorPrincipal: 'gris'
          }
        },
        // Pantalones
        {
          name: 'Pantalón Levi\'s Jean Azul',
          category: 'Pantalón',
          stock: 20,
          priceCost: 3500,
          priceSale: 5800,
          brand: 'Levi\'s',
          supplier: 'Textiles del Sur',
          imageURL: 'https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=400',
          data: {
            tipo: 'jean',
            materialPrincipal: 'denim',
            genero: 'hombre',
            talle: 'M',
            colorPrincipal: 'azul'
          }
        },
        {
          name: 'Pantalón Nike Deportivo Negro',
          category: 'Pantalón',
          stock: 18,
          priceCost: 2800,
          priceSale: 4500,
          brand: 'Nike',
          supplier: 'Proveedor Textil ABC',
          imageURL: 'https://images.unsplash.com/photo-1506629905607-0b2b2b2b2b2b?w=400',
          data: {
            tipo: 'deportivo',
            materialPrincipal: 'poliéster',
            genero: 'unisex',
            talle: 'M',
            colorPrincipal: 'negro'
          }
        },
        {
          name: 'Pantalón Zara Casual Gris',
          category: 'Pantalón',
          stock: 16,
          priceCost: 2200,
          priceSale: 3800,
          brand: 'Zara',
          supplier: 'Moda Express',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'casual',
            materialPrincipal: 'algodón',
            genero: 'mujer',
            talle: 'S',
            colorPrincipal: 'gris'
          }
        },
        // Polleras
        {
          name: 'Pollera Zara Mini Negra',
          category: 'Pollera',
          stock: 12,
          priceCost: 1800,
          priceSale: 3200,
          brand: 'Zara',
          supplier: 'Moda Express',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'mini',
            materialPrincipal: 'algodón',
            genero: 'mujer',
            talle: 'S',
            colorPrincipal: 'negro'
          }
        },
        {
          name: 'Pollera Nike Deportiva Azul',
          category: 'Pollera',
          stock: 10,
          priceCost: 2000,
          priceSale: 3500,
          brand: 'Nike',
          supplier: 'Proveedor Textil ABC',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'deportiva',
            materialPrincipal: 'poliéster',
            genero: 'mujer',
            talle: 'M',
            colorPrincipal: 'azul'
          }
        },
        {
          name: 'Pollera Adidas Midi Gris',
          category: 'Pollera',
          stock: 8,
          priceCost: 2200,
          priceSale: 3800,
          brand: 'Adidas',
          supplier: 'Distribuidora XYZ',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'midi',
            materialPrincipal: 'algodón',
            genero: 'mujer',
            talle: 'L',
            colorPrincipal: 'gris'
          }
        },
        // Pañuelos
        {
          name: 'Pañuelo Seda Cuadrado Rojo',
          category: 'Pañuelo',
          stock: 15,
          priceCost: 800,
          priceSale: 1500,
          brand: 'Zara',
          supplier: 'Moda Express',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'cuadrado',
            materialPrincipal: 'seda',
            genero: 'mujer',
            talle: 'talle único',
            colorPrincipal: 'rojo'
          }
        },
        {
          name: 'Pañuelo Algodón Rectangular Azul',
          category: 'Pañuelo',
          stock: 12,
          priceCost: 600,
          priceSale: 1200,
          brand: 'Nike',
          supplier: 'Proveedor Textil ABC',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'rectangular',
            materialPrincipal: 'algodón',
            genero: 'unisex',
            talle: 'talle único',
            colorPrincipal: 'azul'
          }
        },
        // Sombreros/Gorros/Gorras
        {
          name: 'Gorra Nike Baseball Negra',
          category: 'Sombrero/Gorro/Gorra',
          stock: 20,
          priceCost: 1500,
          priceSale: 2800,
          brand: 'Nike',
          supplier: 'Proveedor Textil ABC',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'baseball',
            materialPrincipal: 'algodón',
            genero: 'unisex',
            talle: 'M',
            colorPrincipal: 'negro'
          }
        },
        {
          name: 'Gorro Adidas Lana Gris',
          category: 'Sombrero/Gorro/Gorra',
          stock: 18,
          priceCost: 1200,
          priceSale: 2200,
          brand: 'Adidas',
          supplier: 'Distribuidora XYZ',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'gorro',
            materialPrincipal: 'lana',
            genero: 'unisex',
            talle: 'M',
            colorPrincipal: 'gris'
          }
        },
        {
          name: 'Sombrero Puma Fedora Marrón',
          category: 'Sombrero/Gorro/Gorra',
          stock: 6,
          priceCost: 2500,
          priceSale: 4200,
          brand: 'Puma',
          supplier: 'Importadora DEF',
          imageURL: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=400',
          data: {
            tipo: 'fedora',
            materialPrincipal: 'cuero',
            genero: 'hombre',
            talle: 'L',
            colorPrincipal: 'marrón'
          }
        },
        // Calzado
        {
          name: 'Zapatillas Nike Air Max Blancas',
          category: 'Calzado',
          stock: 25,
          priceCost: 8000,
          priceSale: 12000,
          brand: 'Nike',
          supplier: 'Distribuidora XYZ',
          imageURL: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400',
          data: {
            tipo: 'zapatillas',
            materialPrincipal: 'sintético',
            genero: 'unisex',
            talle: '42',
            colorPrincipal: 'blanco'
          }
        },
        {
          name: 'Zapatillas Adidas Stan Smith Verdes',
          category: 'Calzado',
          stock: 22,
          priceCost: 6000,
          priceSale: 9500,
          brand: 'Adidas',
          supplier: 'Distribuidora XYZ',
          imageURL: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400',
          data: {
            tipo: 'zapatillas',
            materialPrincipal: 'cuero',
            genero: 'unisex',
            talle: '40',
            colorPrincipal: 'verde'
          }
        },
        {
          name: 'Zapatos Converse All Star Negros',
          category: 'Calzado',
          stock: 20,
          priceCost: 4500,
          priceSale: 7500,
          brand: 'Converse',
          supplier: 'Importadora DEF',
          imageURL: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400',
          data: {
            tipo: 'zapatillas',
            materialPrincipal: 'tela',
            genero: 'unisex',
            talle: '41',
            colorPrincipal: 'negro'
          }
        },
        {
          name: 'Zapatillas Vans Old Skool Negras',
          category: 'Calzado',
          stock: 18,
          priceCost: 5000,
          priceSale: 8500,
          brand: 'Vans',
          supplier: 'Importadora DEF',
          imageURL: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400',
          data: {
            tipo: 'zapatillas',
            materialPrincipal: 'tela',
            genero: 'unisex',
            talle: '39',
            colorPrincipal: 'negro'
          }
        }
      ]
    };
  }

  async generateTestData(): Promise<void> {
    try {
      console.log('🚀 Generando datos de prueba...');
      
      const testData = this.getTestData();
      
      // Crear marcas
      console.log('📦 Creando marcas...');
      for (const brandData of testData.brands) {
        await inventoryService.addBrand(brandData);
      }
      
      // Crear proveedores
      console.log('🚚 Creando proveedores...');
      for (const supplierData of testData.suppliers) {
        await inventoryService.addSupplier(supplierData);
      }
      
      // Crear productos
      console.log('👕 Creando productos...');
      for (const productData of testData.products) {
        const productWithDate = {
          ...productData,
          fechaIngreso: productData.fechaIngreso || new Date().toISOString().split('T')[0]
        };
        await inventoryService.addProduct(productWithDate);
      }
      
      console.log('✅ Datos de prueba generados exitosamente!');
      console.log(`📊 Resumen:`);
      console.log(`   - ${testData.brands.length} marcas creadas`);
      console.log(`   - ${testData.suppliers.length} proveedores creados`);
      console.log(`   - ${testData.products.length} productos creados`);
      
    } catch (error) {
      console.error('❌ Error generando datos de prueba:', error);
      throw error;
    }
  }

  async clearTestData(): Promise<void> {
    try {
      console.log('🗑️ Limpiando datos de prueba...');
      
      // Obtener todos los datos existentes
      const [products, brands, suppliers] = await Promise.all([
        inventoryService.getProducts(),
        inventoryService.getBrands(),
        inventoryService.getSuppliers()
      ]);
      
      // Eliminar productos
      for (const product of products) {
        await inventoryService.deleteProduct(product.id);
      }
      
      // Eliminar marcas
      for (const brand of brands) {
        await inventoryService.deleteBrand(brand.id);
      }
      
      // Eliminar proveedores
      for (const supplier of suppliers) {
        await inventoryService.deleteSupplier(supplier.id);
      }
      
      console.log('✅ Datos de prueba eliminados exitosamente!');
      
    } catch (error) {
      console.error('❌ Error eliminando datos de prueba:', error);
      throw error;
    }
  }

  async resetToTestData(): Promise<void> {
    try {
      console.log('🔄 Reiniciando a datos de prueba...');
      
      // Limpiar datos existentes
      await this.clearTestData();
      
      // Generar nuevos datos de prueba
      await this.generateTestData();
      
      console.log('✅ Sistema reiniciado con datos de prueba!');
      
    } catch (error) {
      console.error('❌ Error reiniciando datos de prueba:', error);
      throw error;
    }
  }
}

// Exportar instancia singleton
export const testDataService = new TestDataService();
export default testDataService;
